module.exports = __webpack_public_path__ + "img/model_19_ug.d07ad69a.jpg";